export const breakpoints = {
    base: '0px',
    xxs: '375px',
    xs: '768px',
    s: '1280px',
    m: '1440px',
    l: '1920px'
}
